import { DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { FormspreeService } from '@shared/services/formspree.service'
import { MessagesService } from '@shared/services/messages.service'

@Component({
  selector: 'app-solicitud-de-alta-modal',
  imports: [ReactiveFormsModule],
  templateUrl: './solicitud-de-alta-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SolicitudDeAltaModalComponent {
  fb = inject(FormBuilder)
  formSpree = inject(FormspreeService)
  messagesService = inject(MessagesService)
  dialogRef = inject(DialogRef)

  loading = signal(false)

  form = this.fb.group({
    codigoSap: ['', Validators.required],
    nombreCompleto: ['', Validators.required],
    modelorama: ['', Validators.required],
    correo: ['', [Validators.required, Validators.email]],
    lada: ['', Validators.required],
    telefono: ['', Validators.required],
    firmoContrato: ['', Validators.required],
    encontroInvitacion: ['', Validators.required]
  })

  async submit() {
    this.loading.set(true)

    try {
      await this.formSpree.sendFormData('xaqvwwbr', this.form.value)

      this.messagesService.successMessage('Tu solicitud ha sido enviada exitosamente. Nos pondremos en contacto contigo pronto.')
      this.dialogRef.close()
    } catch (err) {
      console.log(err)
    } finally {
      this.loading.set(false)
    }
  }
}
